import { useQuery } from '@tanstack/react-query';
import * as _a from '@/lib/api';

export const useAdBanners = () => {
  return useQuery({
    queryKey: ['ad_banners'],
    queryFn: () => _a.ad_banners(),
  });
};
